// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"48fac73c","531":"7ec889a3"}[chunkId] + ".chunk.css";
};